import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImage } from "@fortawesome/free-solid-svg-icons/faFileImage";
import { faFileAudio } from "@fortawesome/free-solid-svg-icons/faFileAudio";
import { faFileVideo } from "@fortawesome/free-solid-svg-icons/faFileVideo";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { faFileWord } from "@fortawesome/free-solid-svg-icons/faFileWord";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { faFilePowerpoint } from "@fortawesome/free-solid-svg-icons/faFilePowerpoint";
import { faFileLines } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { faFileCode } from "@fortawesome/free-solid-svg-icons/faFileCode";
import { faFileZipper } from "@fortawesome/free-solid-svg-icons/faFileZipper";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export const getFontAwesomeIconFromMIME = (mimeType: string) => {
  // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
  const icons: Record<string, IconDefinition> = {
    // Media
    image: faFileImage,
    "image/png": faFileImage,
    audio: faFileAudio,
    video: faFileVideo,
    // Documents
    "application/pdf": faFilePdf,
    "application/msword": faFileWord,
    "application/vnd.ms-word": faFileWord,
    "application/vnd.oasis.opendocument.text": faFileWord,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": faFileWord,
    "application/vnd.ms-excel": faFileExcel,
    "application/vnd.openxmlformats-officedocument.spreadsheetml": faFileExcel,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": faFileExcel,
    "application/vnd.oasis.opendocument.spreadsheet": faFileExcel,
    "application/vnd.ms-powerpoint": faFilePowerpoint,
    "application/vnd.openxmlformats-officedocument.presentationml": faFilePowerpoint,
    "application/vnd.oasis.opendocument.presentation": faFilePowerpoint,
    "text/plain": faFileLines,
    "text/html": faFileCode,
    "application/json": faFileCode,
    // Archives
    "application/gzip": faFileZipper,
    "application/zip": faFileZipper,
  };

  return <FontAwesomeIcon icon={icons[mimeType] ?? faFile} />;
};
